import { useSelector } from "react-redux";

export const useVehicle = () => {
    return useSelector((state) => state.vehicle);
};
